<template>
	<div style="width: 100%">

		<CargaInicial v-if="$root.dominios.cargando"></CargaInicial>

		<div v-else-if="$route.params.dominio">
			Dominio... <v-btn to="constructor" append>Ir a constructor</v-btn>
		</div>

		<v-row v-else>
			<v-col cols="12" sm="6" md="4" lg="2" offset-lg="5" offset-md="4" offset-sm="3">
				<v-alert type="error" :icon="false" class="text-center">
					<v-icon>mdi-alert</v-icon> [4392] Ocurrió un error.
				</v-alert>
			</v-col>
		</v-row>

	</div>
</template>

<script>

import CargaInicial from '@/views/CargaInicial'

export default {
  name: 'dominio-vista',

  data: () => ({
		dominio: null
	}),

	components: {
		CargaInicial,
	},

	watch: {
		'$root.dominios.cargando': function(val) {
			if (val) {
				return
			}

			this.dominio = this.$root.obtenerDominio(this.$route.params.dominio)
		}
	},

	beforeMount: function() {
		this.dominio = this.$root.obtenerDominio(this.$route.params.dominio)
	},

	methods: {
		//
	}
};


</script>